import { useEffect, useState } from "react";

const useGoogleMaps = (apiKey, libraries = ["places"]) => {
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    if (window.google && window.google.maps && window.google.maps.places) {
      setLoaded(true);
      return;
    }

    // Check if script is already in the document
    const existingScript = document.querySelector(
      `script[src*="maps.googleapis.com/maps/api/js"]`
    );
    if (existingScript) {
      existingScript.addEventListener("load", () => setLoaded(true));
      return;
    }

    // Create script element and add it to the document head
    const script = document.createElement("script");
    script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&libraries=${libraries.join(
      ","
    )}`;
    script.async = true;
    script.defer = true;
    script.onload = () => setLoaded(true);
    script.onerror = () =>
      console.error("Error loading Google Maps script:", script.src);
    document.head.appendChild(script);
  }, [apiKey, libraries]);

  return loaded;
};

export default useGoogleMaps;
